import * as types from '../actions/actionTypes';
import initialState from './initialState';


        
        
export default function paisReducer(state= initialState.pais, action){
    let newState;
	switch(action.type){
         case types.LOAD_PAIS_LIST_SUCCESS:		
            action.pais.filtroActivo=state.filtroActivo;
            action.pais.filtroActual=state.filtroActual;
            action.pais.showActivos=state.showActivos;
			 action.pais.paginaActual=action.pais.pageable.pageNumber;
			 action.pais.registrosPorPagina=action.pais.size;
            
            return action.pais;

        case types.BORRAR_PAIS_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(pais => pais.id !== action.pais.id)];          
			return newState;    
            
        case types.ACTIVAR_PAIS_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(pais => pais.id !== action.pais.id)];          
			 return newState;
            
        case types.SET_FILTRO_PAIS:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}